/**
 * The plain control above a report: "everything or only what the skeptic
 * stands behind?". It writes into the room's lens, so it narrows the whole
 * room, as the Narrow drawer does.
 *
 * "Who is this for?" USED TO LEAD. It offered the values of a BUYER axis, from
 * when rooms were software markets framed around who buys; frames are written
 * per market now, and a car wash room has no BUYER axis — the control offered
 * "anyone" and nothing else. "+ Narrow" covers every axis the room has.
 *
 * The rest of the lens — every tag, validation, provenance — is in the room's
 * Narrow drawer on the right rail (`NarrowPanel`); a "+ Narrow" button here
 * read as narrowing this table alone. Whatever is set shows as chips in
 * `LensBar` above.
 */
import type { ReactNode } from 'react';
import type { View } from '../filters';

export default function ReportControls({
  view,
  onView,
  extra,
}: {
  view: View;
  onView: (next: View) => void;
  /** A report's own control (grouping, unit), rendered after the shared two. */
  extra?: ReactNode;
}) {
  const confidentOnly = view.verified === 'HOLDS';

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-gray-600 dark:text-gray-300">
      <div role="radiogroup" aria-label="Show" className="inline-flex rounded border border-gray-300 dark:border-gray-600 overflow-hidden">
        {[
          { key: 'all', label: 'everything', on: !confidentOnly },
          { key: 'confident', label: 'confident only', on: confidentOnly },
        ].map(o => (
          <button
            key={o.key}
            type="button"
            role="radio"
            aria-checked={o.on}
            onClick={() => onView({ ...view, verified: o.key === 'confident' ? 'HOLDS' : null })}
            className={`px-2 py-0.5 border-r last:border-r-0 border-gray-300 dark:border-gray-600 ${
              o.on ? 'bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-100' : 'hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
      {extra}
    </div>
  );
}
